module.exports = __webpack_public_path__ + "media/src/images/cc-bfdd0201948398016dcbf2960c9047ad.png";